import { Component, Vue, Prop } from 'vue-property-decorator';
import InputField from '@/types/InputField';
import Input from '@/components/Input/Input.vue';

@Component({
  components: {
    Input,
  },
})

export default class Form extends Vue {
  @Prop() public readonly inputFields!: [InputField];
  @Prop() public readonly submitText!: string;
  @Prop() public readonly error!: string | null;
  @Prop({default: false}) public readonly disableForm!: boolean;

  public submitForm(): void {
    this.$emit(
      'submitFn',
    );
  }
}
